/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyUploadedDataPackage } from './CompanyUploadedDataPackage';
import {
    CompanyUploadedDataPackageFromJSON,
    CompanyUploadedDataPackageFromJSONTyped,
    CompanyUploadedDataPackageToJSON,
    CompanyUploadedDataPackageToJSONTyped,
} from './CompanyUploadedDataPackage';

/**
 * 
 * @export
 * @interface PaginatedCompanyUploadedDataPackageList
 */
export interface PaginatedCompanyUploadedDataPackageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompanyUploadedDataPackageList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyUploadedDataPackageList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompanyUploadedDataPackageList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<CompanyUploadedDataPackage>}
     * @memberof PaginatedCompanyUploadedDataPackageList
     */
    results: Array<CompanyUploadedDataPackage>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompanyUploadedDataPackageList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedCompanyUploadedDataPackageList interface.
 */
export function instanceOfPaginatedCompanyUploadedDataPackageList(value: object): value is PaginatedCompanyUploadedDataPackageList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedCompanyUploadedDataPackageListFromJSON(json: any): PaginatedCompanyUploadedDataPackageList {
    return PaginatedCompanyUploadedDataPackageListFromJSONTyped(json, false);
}

export function PaginatedCompanyUploadedDataPackageListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCompanyUploadedDataPackageList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(CompanyUploadedDataPackageFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedCompanyUploadedDataPackageListToJSON(json: any): PaginatedCompanyUploadedDataPackageList {
    return PaginatedCompanyUploadedDataPackageListToJSONTyped(json, false);
}

export function PaginatedCompanyUploadedDataPackageListToJSONTyped(value?: PaginatedCompanyUploadedDataPackageList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(CompanyUploadedDataPackageToJSON)),
        'num_pages': value['numPages'],
    };
}

